/**
 * VueX Store Utils
 * @author Bailey Kulman (Fresche Solutions)
 * @date July 2025
 */

/**
 * Resets Vuex state properties back to their default values.
 * Uses structuredClone to deep-copy each default value, preventing shared
 * object/array references between the live state and DEFAULT_STATE constants.
 * Without deep cloning, arrays/objects in DEFAULT_STATE would be mutated by
 * normal state operations, causing data to "leak" between user sessions.
 */
export function resetStateData(state, defaultState)
{
    for (let property in defaultState) {
        state[property] = structuredClone(defaultState[property]);
    }

    return state;
};
